<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('readCommentList.title')" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('readCommentList.content')" prop="content">
          <el-input type="textarea" :rows="5" v-model="ruleForm.content"></el-input>
        </el-form-item>
        <el-form-item :label="$t('readCommentList.commentator')" prop="commentator">
          <el-input v-model="ruleForm.commentator"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
        $t("btnTip.submit")
      }}</el-button>
    </el-card>
  </div>
</template>
<script>
import { readCommentDetail, addReadComment, editReadComment } from "@/api/api";
export default {
  name: "editRead",
  data() {
    return {
      ruleForm: {
        title: "",
        commentator: "",
        content: "",
        club_id: this.$route.params.readId,
      },
      rules: {
        title: [
          {
            required: true,
            message: this.$t("readCommentList").title,
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("readCommentList").content,
            trigger: "blur",
          },
        ],
        commentator: [
          {
            required: true,
            message: this.$t("readCommentList").commentator,
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t("btnTip").add
        : this.$t("btnTip").edit;
    },
  },
  methods: {
    async submitForm(formName) {
      await this.$refs[formName].validate();
      if (this.id === undefined) {
        await addReadComment(this.ruleForm);
      } else {
        delete this.ruleForm.create_time;
        delete this.ruleForm.publisher_name;
        delete this.ruleForm.type;
        await editReadComment(this.ruleForm);
      }
      this.$router.go(-1);
    },
    async get_info() {
      const information = await readCommentDetail(this.id);
      this.ruleForm = { ...information };
    },
  },
  async created() {
    if (this.id === undefined) return
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
</style>
